export default "__VITE_ASSET__CwSf65gO__"